window.datepickerDefaults = {
  dateFormat: 'yy-mm-dd',
  showButtonPanel: true,
  changeMonth: true,
  changeYear: true,
  minDate: '-10Y',
  maxDate: '+1Y',
  yearRange: '-80:+1',
  stepMinute: 5,
  hourMin: 6,
  hourGrid: 4,
  minuteGrid: 10
}

window.datepickerMonthDefaults = {
  dateFormat: 'yy-mm',
  showButtonPanel: true,
  changeMonth: true,
  changeYear: true
}

window.datetimepickerDefaults = {
  format: 'Y-m-d H:i'
}

window.accordionDefaults = {
  navigation: true,
  collapsible: true,
  heightStyle: 'content'
}
